document.addEventListener('DOMContentLoaded', function() {
  // We target a wider screen size to be safe for tablets.
  if (window.innerWidth < 990) {
    return;
  }

  const menuItems = document.querySelectorAll('.header__inline-menu details');

  menuItems.forEach(item => {
    // Event for when the mouse enters the menu item area
    item.addEventListener('mouseover', () => {
      // Only open if it's not already open (e.g., from a click)
      if (!item.hasAttribute('open')) {
        // Mark it as opened by hover
        item.dataset.hoverOpened = 'true';
        item.setAttribute('open', '');
      }
    });

    // Event for when the mouse leaves the menu item area
    let closeTimer;
    item.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    item.addEventListener('mouseleave', () => {
      // Only close if it was opened by the hover event
      if (item.dataset.hoverOpened === 'true') {
        closeTimer = setTimeout(() => {
          item.removeAttribute('open');
          delete item.dataset.hoverOpened;
        }, 200);
      }
    });

    // We need to handle clicks on the summary element
    const summary = item.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', () => {
        // When a user clicks, we remove the hover-opened state.
        // This "locks" the menu open (or closed) until the next click,
        // preventing mouseleave from closing a clicked-open menu.
        delete item.dataset.hoverOpened;
      });
    }
  });
});